import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { Options } from "../utils/decorators";
import Detector from "../utils/detector";
import axios from 'axios';
import "url-polyfill";

const Weglot = (<any>window).Weglot;
const weglotKey = (<any>window).DJANGO.weglotKey;
const currentHost = (<any>window).DJANGO.currentHost;
const localStorage = (<any>window).localStorage;

const cache = {};

const isDev = false;

@Options({
    template: false,
    el: "body",
})
export default class RootView extends Marionette.View<Backbone.Model>{

    get detector():Detector {
        return this._detector;
    }

    set detector(value:Detector) {
        if (value != this._detector) {
            this._detector = value;
        }
    }

    get observer():MutationObserver {
        return this._observer;
    }

    set observer(value:MutationObserver) {
        if (value != this._observer) {
            this._observer = value;
        }
    }

    getLangFrom(){
        if (isDev){
            return 'en'; // used for testing
        } else {
            return Weglot.options.language_from;
        }
    }

    getLangTo(){
        if (isDev){
            return 'es'; // used for testing
        } else {
            return Weglot.getCurrentLang();

        }
    }

    getRequestUrl(){
        if(isDev){
            return  'https://es.laphil.com';
        } else {
            return location.href;
        }
    }

    _detector: Detector;
    _observer: MutationObserver;

    constructor(options?:object) {
        super(options);

        this.detector = new Detector();
        this.detector.detect();

        //Run other methods only after initialized
        const interval = setInterval(()=> {
            if (!Weglot.initialized) {
                return;
            }

            clearInterval(interval);

            this.translator();
        }, 100);
    }

    // Returns an array of keys for translaslated texts - from cache
    getNodesForUncachedTranslations(nodes) {
        const ttl = 300 * 1000;
        const time = Date.now();

        const langTo = this.getLangTo();
        const langFrom = this.getLangFrom();

        let uncachedNodes = [];
        let cachedNodes = [];

        for (let loopIndex = 0; loopIndex < nodes.length; loopIndex++) {
            const key = langTo + this.hashKey(nodes[loopIndex].innerHTML);

            if (key in cache) {
                // Check if it is time to refresh this value as the cached version for it is outdated (?)
                let cached = cache[key];

                if (!cached) {
                    // Add to the uncached so that it can be returned
                    uncachedNodes.push(nodes[loopIndex]);
                }
                else {
                    if (cached.expiry < time) {
                        // Also push into uncached - but display the cached value for now
                        cachedNodes.push(nodes[loopIndex]);
                        uncachedNodes.push(nodes[loopIndex]);
                    }
                    else {
                        // This is a node with cached translation
                        cachedNodes.push(nodes[loopIndex]);
                    }
                }
            }
            else if (this.getItem(key)) {

                let cached = this.getItem(key);

                if (cached.expiry < time) {
                    // Also push into uncached - but display the cached value for now
                    cachedNodes.push(nodes[loopIndex]);
                    uncachedNodes.push(nodes[loopIndex]);
                }
                else {
                    // This is a node with cached translation
                    cachedNodes.push(nodes[loopIndex]);
                }
            }
            else {
                // Add to the uncached so that it can be returned
                uncachedNodes.push(nodes[loopIndex]);
            }
        }

        // Now work the cached values
        if (cachedNodes.length > 0) {
            for (let lindex = 0; lindex < cachedNodes.length; lindex++) {

                let node = cachedNodes[lindex];

                const key = langTo + this.hashKey(node.innerHTML);

                // Set data-auto-translate to false on node
                node.setAttribute('data-auto-translate', false);

                // Grab all em tags before translation and store
                const emsBefore = node.querySelectorAll('em');
                let emsBeforeArray = [];

                for(let i = 0; i<emsBefore.length; i++) {
                    emsBeforeArray.push(emsBefore[i].textContent);
                }

                let cached = this.getItem(key);

                if (cached !== null) {
                    if (typeof cached === 'object') {
                        node.innerHTML = cached.value;
                    }
                    else {
                        node.innerHTML = cached;
                    }
                }
                else {
                    continue;
                }

                // Repopulate em tags with original content
                [].forEach.call(node.querySelectorAll('em'), (emAfter, index) => {
                    emAfter.textContent = ' ' + emsBeforeArray[index] + ' ';
                });

                const deferred = $.Deferred();
                deferred.resolve(cached.value);
                cache[key] = deferred.promise();
            }
        }

        // Finally, return the uncached nodes
        return uncachedNodes;
    }

    translator() {

        if(!isDev){
            if (Weglot.options.language_from === Weglot.getCurrentLang()) {
                return;
            }
        }

        const targetNode = this.$el.get(0);

        // this.observer = new MutationObserver(list => {

        //         const nodes = document.querySelectorAll('[data-auto-translate="true"]');
        //         // Get all the uncached nodes
        //         let uNodes = this.getNodesForUncachedTranslations(nodes);

        //         if (uNodes.length > 0) {

        //             let emsBeforeArray = [];
        //             // + for setting local storage time-to-live
        //             const ttl = 300 * 1000;
        //             const time = Date.now();
        //             // + for translation keys and local storage

        //             const langTo = this.getLangTo();
        //             const langFrom = this.getLangFrom();

        //             // Get the translations for these too
        //             for (let loopIndex = 0; loopIndex < uNodes.length; loopIndex++) {
        //                 // Grab all em tags before translation and store
        //                 const emsBefore = uNodes[loopIndex].querySelectorAll('em');

        //                 for(let i = 0; i<emsBefore.length; i++) {
        //                     emsBeforeArray.push(emsBefore[i].textContent);
        //                 }
        //             }

        //             let storageKeys = [];
        //             for (let lindex = 0; lindex < nodes.length; lindex++) {
        //                 let storageKey = langTo + this.hashKey(nodes[lindex].innerHTML);
        //                 storageKeys[lindex] = storageKey;
        //             }

        //             // Ask for the translations now
        //             let promisedTranslations = this.doTranslateMultipleFromAPI(uNodes);

        //             promisedTranslations.then((translations) => {

        //                 // Do a global check for when the whole translations response would be undefined
        //                 if (typeof translations !== 'undefined') {

        //                     for (let lindex = 0; lindex < translations.nodes.length; lindex++) {
        //                         // Get the current node - use it as a local variable
        //                         let node = translations.nodes[lindex];

        //                         // Set data-auto-translate to false on node
        //                         node.setAttribute('data-auto-translate', 'false');

        //                         // Do checks for undefined values
        //                         if ((typeof translations.to_words !== 'undefined') && (typeof translations.to_words[lindex] !== 'undefined')) {

        //                             // Apply the value returned from the translator
        //                             node.innerHTML = translations.to_words[lindex];
        //                             // Repopulate em tags with original content
        //                             [].forEach.call(node.querySelectorAll('em'), (emAfter, index) => {
        //                                 emAfter.textContent = ' ' + emsBeforeArray[index] + ' ';
        //                             });

        //                             localStorage.setItem(storageKeys[lindex], JSON.stringify({
        //                                 value: translations.to_words[lindex],
        //                                 expiry: time + ttl,
        //                             }));

        //                         }
        //                     }

        //                 }
        //             });
        //         }
        // });

        // this.observer.observe(targetNode, {
        //     childList: true,
        //     subtree: true,
        // });
    }

    hashKey(string) {
        let hash = 0, i = 0, len = string.length;
        while ( i < len ) {
            hash  = ((hash << 5) - hash + string.charCodeAt(i++)) << 0;
        }
        return hash
    }

    getItem(key) {
        const item = localStorage.getItem(key);

        try {
            return JSON.parse(item);
        } catch(e) {
            return null;
        }
    }

    /**
     * Asks for translations for multiple values.
     * @param nodes
     */
    doTranslateMultipleFromAPI(nodes) {

        const langTo = this.getLangTo();
        const langFrom = this.getLangFrom();

        return this.postRequestMultiple(langTo, langFrom, nodes);
    }

    doTranslate(words) {

        const ttl = 300 * 1000;
        const time = Date.now();

        const langTo = this.getLangTo();
        const langFrom = this.getLangFrom();

        const key = langTo + this.hashKey(words);

        if (key in cache) {
            return cache[key];
        }

        let cached = this.getItem(key);

        let translation = null;

        if (!cached) {
            translation = this.postRequest(langTo, langFrom, words);

            cache[key] = translation.then(response => {
                if (!response) {
                    return null;
                }

                localStorage.setItem(key, JSON.stringify({
                    value: response,
                    expiry: time + ttl,
                }));

                return response;
            });
        } else {
            if (cached.expiry < time) {
                translation = this.postRequest(langTo, langFrom, words);

                translation.then(response => {
                    if (!response) {
                        return null;
                    }

                    localStorage.setItem(key, JSON.stringify({
                        value: response,
                        expiry: time + ttl,
                    }));

                    return response;
                });
            }

            const deferred = $.Deferred();

            deferred.resolve(cached.value);

            cache[key] = deferred.promise();
        }

        return cache[key];
    }

    postRequestMultiple(langTo, langFrom, nodes) {
        // Lets build an array of objects to be passed to the translating api
        let wordsArray = [];
        for (let lindex = 0; lindex < nodes.length; lindex++) {
            wordsArray.push({"w":nodes[lindex].innerHTML, "t":1});
        }

        const options = {
            method: 'POST',
            url: 'https://api.weglot.com/translate?api_key=' + weglotKey,
            data: {
                l_to: langTo,
                l_from: langFrom,
                words: wordsArray,
                request_url : this.getRequestUrl()
            },
        }
        // And now lets fire-up the asynchronous request to get the translations from the external api
        return axios(options).then(response => {
            let data = response.data;
            data.nodes = nodes;
            if (_.isObject(data) === false) {
                return null;
            }

            if (_.has(data, 'to_words') === false || data.to_words.length === 0) {
                return null;
            }

            return data;
        }).catch(error => {
            console.log(error);
        });
    }

    postRequest(langTo, langFrom, words) {
        const options = {
            method: 'POST',
            url: 'https://api.weglot.com/translate?api_key=' + weglotKey,
            data: {
                l_to: langTo,
                l_from: langFrom,
                words: [
                    {
                        w: words,
                        t: 1,
                    },
                ],
                request_url : this.getRequestUrl()
            },
        }

        return axios(options).then(response => {
            const data = response.data;

            if (_.isObject(data) === false) {
                return null;
            }

            if (_.has(data, 'to_words') === false || data.to_words.length === 0) {
                return null;
            }

            return data.to_words[0];
        });
    }

    getRequest(langTo, langFrom, words) {
        const host = currentHost
            .replace('cms.', 'www.')
            .replace('es.', 'www.')
            .replace('hollywoodbowl.', 'laphil.')
            .replace('theford.', 'laphil.');

        let params = {
            to: langTo,
            from: langFrom,
            word: words,
            type: 1,
        };

        // @ts-ignore
        params = new URLSearchParams(params);

        const options = {
            method: 'GET',
            url: host + '/weglot/translate-one?' + params.toString(),
        }

        return axios(options).then(response => {
            return response.data;
        });
    }
}



// WEBPACK FOOTER //
// ./@modules/web/root-view.ts